const PII_FIELD_NAMES = ['email', 'phone', 'first_name', 'firstName', 'last_name', 'lastName'];

const REDACTED = '[REDACTED]';

export const redactPii = <T>(input: T, seen = new WeakSet<object>(), depth = 0): T => {
  if (!input || typeof input !== 'object' || depth > 10) {
    return input;
  }

  if (seen.has(input)) {
    return '[Circular]' as unknown as T;
  }

  seen.add(input);

  if (Array.isArray(input)) {
    return input.map((item) => redactPii(item, seen, depth + 1)) as T;
  }

  return Object.fromEntries(
    Object.entries(input).map(([key, value]) =>
      PII_FIELD_NAMES.includes(key) ? [key, REDACTED] : [key, redactPii(value, seen, depth + 1)]
    )
  ) as T;
};
